import Title from "../components/ui/Title";
import { Alert } from "../components/ui/alert";
import { Skeleton } from "../components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import FactureRowItem from "../components/factures/FactureRowItem";
import { useFactures } from "@/lib/hooks/useFacture";
import { FileText, Inbox } from "lucide-react";

const LoadingRows = () => (
  <>
    {[0, 1, 2].map((item) => (
      <TableRow key={item}>
        <TableCell colSpan={5} className='px-5 py-4 sm:px-6'>
          <Skeleton className='h-12 w-full' />
        </TableCell>
      </TableRow>
    ))}
  </>
);

const EmptyRow = () => (
  <TableRow>
    <TableCell colSpan={5} className='py-12 text-center'>
      <div className='flex flex-col items-center text-slate-500'>
        <Inbox className='mb-3 h-8 w-8 text-slate-300' />
        <span className='font-medium text-slate-700'>Aucune facture disponible</span>
        <span className='mt-1 text-sm'>Vos prochaines factures apparaîtront ici.</span>
      </div>
    </TableCell>
  </TableRow>
);

const FacturesPage = () => {
  const { data: factures, isError } = useFactures();

  return (
    <div className='mx-auto w-full max-w-7xl pb-8'>
      <div className='mb-7'>
        <Title>Mes factures</Title>
        <p className='mt-2 max-w-2xl text-sm leading-6 text-slate-600 md:text-base'>
          Retrouvez vos paiements et téléchargez vos justificatifs de facturation.
        </p>
      </div>

      {isError && (
        <Alert variant='destructive' className='mb-6'>
          Impossible de charger vos factures. Réessayez dans quelques instants.
        </Alert>
      )}

      {!isError && (
        <section className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_14px_40px_-34px_rgba(15,23,42,0.5)]'>
          <div className='flex items-center gap-3 border-b border-slate-100 bg-[#fbfaf6] px-5 py-4 sm:px-6'>
            <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#f1e8c9] text-[#755c14]'>
              <FileText className='h-5 w-5' />
            </div>
            <div>
              <h2 className='font-bold text-slate-950'>Toutes les factures</h2>
              <p className='text-sm text-slate-500'>Classées de la plus récente à la plus ancienne</p>
            </div>
          </div>

          <Table>
            <TableHeader className='hidden bg-slate-50/70 sm:table-header-group'>
              <TableRow className='hover:bg-transparent'>
                <TableHead className='w-[150px] px-6'>Date</TableHead>
                <TableHead className='min-w-[240px]'>Description</TableHead>
                <TableHead>Montant</TableHead>
                <TableHead>Statut</TableHead>
                <TableHead className='px-6 text-right'>Document</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {!factures ? (
                <LoadingRows />
              ) : factures.length === 0 ? (
                <EmptyRow />
              ) : (
                factures.map((fac) => <FactureRowItem key={fac.id} facture={fac} />)
              )}
            </TableBody>
          </Table>
        </section>
      )}
    </div>
  );
};

export default FacturesPage;
